export default "__VITE_ASSET__2339c296__"